// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6925 ? "2c386607" : chunkId) + "." + {"6925":"3c4b7506d9023736","9651":"9be695e992890e60"}[chunkId] + ".js";
};